// extracted by mini-css-extract-plugin
module.exports = {"hero":"home_hero__El_K3","heroSection":"home_heroSection___wqyR"};